import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {environment} from "../../../environments/environment";
import {RoleInstitution} from "../../models/role-institution";
import Helpers from "../../utils/helpers";

@Injectable()
export class RoleUnitControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getRoleUnit(roleInstitutionId: string) {
    return this.http.get(this.baseUrl + "role_unit/" + roleInstitutionId);
  }

  public getRoleUnitList(roleId: string) {
    return this.http.get(this.baseUrl + "role/" + roleId + "/role_unit");
  }

  public saveRoleUnit(roleId: string, roleUnit: RoleInstitution) {
    Helpers.trimRecursiveObj(roleUnit);
    const body = JSON.stringify(roleUnit);
    return this.http.post(this.baseUrl + "role/" + roleId + "/role_unit", body);
  }

  public deleteRoleUnit(roleInstitutionId: string) {
    return this.http.delete(this.baseUrl + "role_unit/" + roleInstitutionId, {responseType: "text"});
  }

}
